import { Box, CircularFrame, ContentFrame, Icon, LayoutContent, LayoutControls, Typography, } from '@pinwheel/origami';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import CompanyIcon from '../../components/CompanyIcon';
import Actions from './Action/TemplateFormActions';
import { useOpts } from '../../context';
import { selectEmployerFromContext, selectLoadedPlatform, } from '../../state/slices/slice-link-api';
import SearchProviderButton from '../../components/SearchProviderButton';
import LoginButton from '../../components/LoginButton';
function TemplateProviderSelection(_a) {
    var submitStep = _a.submitStep, linkApiResponse = _a.linkApiResponse;
    var opts = useOpts();
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var employer = useSelector(selectEmployerFromContext);
    var onClick = useCallback(function (provider) {
        var _a;
        opts.setLoadedPlatform(provider.platform);
        if (provider.employer)
            opts.setSelectedEmployer(provider.employer);
        submitStep((_a = {},
            _a[linkApiResponse.template.key] = provider[linkApiResponse.template.key],
            _a));
    }, [submitStep, opts, linkApiResponse]);
    var elements = useMemo(function () {
        return linkApiResponse.template.providerGroups.map(function (g, i) {
            var providerList = g.providers.map(function (p, j) {
                var _a, _b;
                return linkApiResponse.template.templateSubtype === 'authentication' ? (React.createElement(LoginButton, { key: "".concat(i, ".").concat(j), "data-testid": "provider".concat(i, ".").concat(j), eventId: "providerSelected-".concat(((_a = p.platform) === null || _a === void 0 ? void 0 : _a.id) || ''), provider: p, onClick: onClick, 
                    /* There are always two platforms for confirmation screen with authentication subtype:
                     * first login with credentials and second login with PII
                     */
                    type: j === 0 ? 'credentials' : 'pii' })) : (React.createElement(SearchProviderButton, { key: "".concat(i, ".").concat(j), "data-testid": "provider".concat(i, ".").concat(j), defaultIcon: "genericPayrollProvider", eventId: "providerSelected-".concat(((_b = p.platform) === null || _b === void 0 ? void 0 : _b.id) || ''), provider: p, onClick: onClick }));
            });
            return (React.createElement(Box, { key: i, sx: { marginBottom: 0 } },
                React.createElement(Typography, { variant: "label", color: "light", sx: { margin: '8px 0' } }, g.group),
                providerList));
        });
    }, [onClick, linkApiResponse]);
    return (React.createElement(ContentFrame, { "data-testid": "TemplateProviderSelection" },
        React.createElement(LayoutContent, { onSubmit: function (e) { return e.preventDefault(); } },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '16px',
                    marginBottom: 0,
                } },
                React.createElement(CompanyIcon, { size: "lg", result: {
                        logoUrl: (employer === null || employer === void 0 ? void 0 : employer.logoUrl) || (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.logoUrl),
                    } }),
                // Design-wise, it looks visually odd if we show a mapping of two generic icons, so instead we want to only
                // show a single generic icon in that case. Context: https://pinwheel.atlassian.net/browse/CON-459
                opts.featureFlags.useGenericProviderLogos ? null : (React.createElement(React.Fragment, null,
                    React.createElement(Icon, { sx: { margin: '16px' }, icon: "connector" }),
                    React.createElement(CircularFrame, { loading: false, size: "lg", backgroundColorInner: {
                            type: 'theme',
                            colorLegacy: 'Neutral/50',
                            colorNext: 'neutral/default',
                            opacityNext: 0.7,
                        } },
                        React.createElement(Icon, { icon: "genericPayrollProvider", size: 48, color: {
                                type: 'theme',
                                colorLegacy: 'Neutral/0',
                                colorNext: 'background/default',
                            } }))))),
            React.createElement(Typography, { sx: {
                    marginTop: '8px',
                    marginBottom: '8px',
                }, variant: "header", color: "title", align: "center" }, linkApiResponse.template.title),
            React.createElement(Typography, { sx: {
                    marginBottom: '2',
                }, variant: "caption", color: "default", align: "center" }, linkApiResponse.template.subtitle),
            React.createElement(Box, { sx: { paddingTop: '16px' } }, elements)),
        React.createElement(LayoutControls, null,
            React.createElement(Typography, { sx: {
                    marginTop: '3',
                    marginBottom: '1',
                }, color: "default", variant: "caption", align: "center" }, linkApiResponse.template.footer),
            React.createElement(Actions, { actions: linkApiResponse.template.actions, onSubmit: function () { } }))));
}
export default TemplateProviderSelection;
